const getRequestEventId = (request) =>
  request?.eventId ?? request?.event_id ?? request?.sourceEventId ?? request?.logEventId ?? null;

const getRequestEntryId = (request) =>
  request?.entryId ?? request?.entry_id ?? request?.id ?? null;

const getRequestMinutesFrom = (request) =>
  request?.minutesFrom ?? request?.minutes_from ?? null;

const normalizeRequest = (request) => {
  if (request == null) return null;
  if (typeof request === 'string' || typeof request === 'number') {
    return { eventId: request };
  }
  return request;
};

export const findEntryForActiveRequest = (request, entries = []) => {
  const normalized = normalizeRequest(request);
  if (!normalized || !entries.length) return null;

  const eventId = getRequestEventId(normalized);
  const entryId = getRequestEntryId(normalized);
  const minutesFrom = getRequestMinutesFrom(normalized);

  return (
    entries.find((entry) => {
      if (eventId != null && entry?.eventId != null && String(entry.eventId) === String(eventId)) {
        return true;
      }
      if (
        entryId != null &&
        (String(entry?.id) === String(entryId) || String(entry?.key) === String(entryId))
      ) {
        return true;
      }
      if (
        minutesFrom != null &&
        entry?.minutes_from != null &&
        Number(entry.minutes_from) === Number(minutesFrom)
      ) {
        return true;
      }
      return false;
    }) || null
  );
};

export const formatPendingEventLabel = (request, entry) => {
  const normalized = normalizeRequest(request);
  const timeFrom = entry?.time_from || normalized?.timeFrom || normalized?.time_from;
  const timeTo = entry?.time_to || normalized?.timeTo || normalized?.time_to;
  const status = entry?.status || normalized?.status || 'DRIVING';
  const timeRange = timeFrom && timeTo ? `${timeFrom} – ${timeTo}` : timeFrom || '';

  if (timeRange) return `${status} ${timeRange}`;
  return status;
};

export const getPendingReassignmentMessage = ({ type, meta, entries, i18n, fallbackKey }) => {
  const requests = meta?.activeRequests || [];
  if (!requests.length) {
    return meta?.disabledReason || i18n.t(fallbackKey);
  }

  const typeLabel =
    type === 'ud' ? i18n.t('logs.reassignTypeUd') : i18n.t('logs.reassignTypeCoDriver');
  const event = requests
    .map((request) => formatPendingEventLabel(request, findEntryForActiveRequest(request, entries)))
    .join(', ');

  return i18n.t('logs.reassignPendingWithEvent', { type: typeLabel, event });
};
